'use client';

import { useEffect } from 'react'

function Modal({ isOpen, onClose, children, className, id }) {

  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;

    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  return (
    <div id={id} className={`fixed w-screen h-[100dvh] top-0 left-0 
      bg-black/[.4] z-40 flex items-center justify-center overflow-y-auto  
      ${className}`}>

      <div className='z-[41] h-full w-full absolute' onClick={onClose && onClose} />

      {children}
    </div>
  )
}

function Wrapper({ isOpen, children, ...props }) {
  if (!isOpen) return null;
  return <Modal {...props} isOpen={isOpen}>{children}</Modal>
}

export default Wrapper
